import React, { useState } from "react";
import { Box, Tabs, Tab, Paper, Fade } from "@mui/material";
import ResponseLayout from "./ResponseLayout";
import CalibrationLayout from "./CalibrationLayout";
import PredictionLayout from "./PredictionLayout";

export default function NavigationTabs() {
    const [activeTab, setActiveTab] = useState(0);

    const handleChange = (event, newValue) => setActiveTab(newValue);

    const tabs = [
        { label: "Response", component: <ResponseLayout /> },
        { label: "Calibration", component: <CalibrationLayout /> },
        { label: "Prediction", component: <PredictionLayout /> }
    ];

    return (
        <Paper
            elevation={1}
            sx={{
                width: "100%",
                margin: "10px",
                mt: 2,
                borderRadius: 2,
                overflow: "hidden"
            }}
        >
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    textColor="inherit"
                    indicatorColor="none"
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "1rem",
                            minWidth: 200,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            color: "white",
                            backgroundColor: "#774def",
                            transition: "none"
                        },
                        "& .MuiTab-root:hover": {
                            color: "white",
                            fontWeight: 600,
                            fontSize: "1.1rem",
                            backgroundColor: "#774def"
                        },
                        "& .Mui-selected": {
                            color: "white",
                            backgroundColor: "#774def",
                            boxShadow: "none"
                        },
                        "& .MuiTabs-indicator": { display: "none" }
                    }}
                >
                    {tabs.map((t, i) => <Tab key={i} label={t.label} />)}
                </Tabs>
            </Box>

            <Box sx={{ position: "relative", minHeight: 500, overflow: "hidden" }}>
                {tabs.map((t, i) => (
                    <Fade key={i} in={activeTab === i} timeout={300} unmountOnExit>
                        <Box
                            sx={{
                                position: activeTab === i ? "relative" : "absolute",
                                width: "100%",
                                height: "100%"
                            }}
                        >
                            {t.component}
                        </Box>
                    </Fade>
                ))}
            </Box>
        </Paper>
    );
}
